<template>
  <div>
    <div class="head_top">
      <img src="../assets/Img/logo.png"
           class="logo"
           style="" />
      <div class="topRight"
           v-if="loginData">
        <div class="navtitle"
             @click="loginout">退出</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toHelp">帮助</div>

        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toUploadJX">捐赠</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             v-text="loginData"
             @click="personInfo">欢迎您！华中师范大学</div>
        <div class="navtitle_line"
             style="cursor: pointer;"
             @click="personInfo">
          <img style="width: 30px; height: 30px; margin-top: -3px;"
               src="../assets/Img/person/avator.png" />
        </div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toList">地方志</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toIndex">首页</div>
      </div>
      <div class="topRight"
           v-else>
        <div class="navtitle"
             style="margin-right: 30px;"
             @click="toHelp">帮助</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toRegister">注册</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toLogin">登录</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toList">地方志</div>
        <div class="navtitle_line">|</div>
        <div class="navtitle"
             @click="toIndex">首页</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Header",
  data () {
    return {
      loginData: '',
    };
  },
  mounted () {
    if (sessionStorage.loginData) {
      this.loginData = JSON.parse(sessionStorage.loginData).username;
    }
  },
  methods: {
    toUpload () {
      this.$router.push("/Upload");
    },
    toUploadJX () {
      this.$router.push("/UploadPageJX");
    },
    toHelp () {
      this.$router.push("/autoReplayPage");
    },
    toIndex () {
      this.$router.push("/index");
    },
    toList () {
      this.$router.push("/DiFangZhi1");
    },
    toRegister () {
      this.$router.push("/register");
    },
    toLogin () {
      this.$router.push("/login");
    },
    loginout () {
      this.loginData = '';
      sessionStorage.clear();
      this.$router.push("/login");
    },
    personInfo () {
      this.$router.push("/personal");
    },

  },
  computed: {
    isLogin () {
      const loginData = sessionStorage.getItem('loginData');
      return !!loginData
    },
    userinfo () {
      const loginData = sessionStorage.getItem('loginData');
      return JSON.parse(loginData)
    }
  },
}
</script>

<style scoped>
.logo {
  width: 420px;
  height: auto;
  margin-left: 10%;
  margin-top: 10px;
}
.topRight {
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-size: 14px;
  margin-top: 26px;
  float: right;
  margin-right: 10%;
}
.navtitle {
  float: right;
  margin-left: 10px;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
}
.navtitle_line {
  float: right;
  margin-left: 10px;
  font-size: 18px;
  font-weight: 700;
}
.navtitle:hover {
  color: #00f1ff;
  padding-bottom: 5px;
  border-bottom: 2px solid #10e8fa;
}
.head_top {
  height: 70px;
  background: rgb(22, 83, 146);
  opacity: 0.8;
}
</style>